import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import useDefaultPage from '../utils/useDefaultPage';

const DEFAULT_DEFAULT_PAGE = '/apps/quaysideOverview';

export default function DefaultRoute() {
    const location = useLocation();

    const { defaultPage, isFetching } = useDefaultPage();

    if (isFetching) {
        return null;
    }

    const redirectUrl = isEmpty(defaultPage)
        ? DEFAULT_DEFAULT_PAGE
        : defaultPage;

    return <Redirect to={{ ...location, pathname: redirectUrl }} />;
}
